import { render, staticRenderFns } from "./incentive-by-item-edit.vue?vue&type=template&id=35f2d0e6&"
import script from "./incentive-by-item-edit.vue?vue&type=script&lang=js&"
export * from "./incentive-by-item-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports